export const home = {
  seo: {
    title: 'Bistroo - Ordering Software for Restaurants & Hospitality',
    description: 'The most affordable and flexible (white-label) ordering software for restaurants. Manage online orders, retain customer data and strengthen your own brand.',
  },
  hero: {
    pill: {
      label: 'We simply serve',
      text: 'Restaurants',
    },

    heading: {
      title: 'Guests order through your own',
      words: ['webshop', 'website', 'POS', 'kiosk', 'QR code'],
    },

    saving_time: 'We save you time and increase your profits.',
    boosting_business: 'We boost your online business.',

    header_mockup_alt: 'Dashboard & Landing page',
    partners_alt: 'Trusted by our partners',
  },
  landing_pages: {
    heading: {
      create: 'Create',
      your_restaurant: 'a website or webshop',
      shop_in_minutes: 'for your restaurant in minutes',
    },

    personalized_webshop:
      'A personalized webshop and website for your restaurant, online in no time.',
    start_free: 'Start free today and choose from 1000+ customizable designs.',

    actions: {
      create_your_website: 'Create your website',
    },
  },
  key_features: {
    pill: {
      label: 'Key features',
      text: 'All you need to know',
    },

    heading: 'Everything you need for online ordering',

    personalize_order_experience:
      'Personalize your customers\' ordering experience with our fully customizable online',
    boost_sales:
      'ordering system. Discover the tools to grow your restaurant while saving on costs.',

    cards: {
      order_management_with_ease: {
        title: 'Easy order management.',
        text: 'Offer your customers a personalized ordering experience with our fully self-configurable online webshop manager.',
        button: 'View the manager',
      },
      plug_and_play: {
        title: 'Plug-and-play.',
        text: 'Get started within minutes with our Bistroo Device or use your own phone or laptop.',
      },
      peak_times: {
        title: 'Manage busy peak times.',
        text: 'Adjust settings in real time.',
      },
      instant_payments: {
        title: 'Instant payments.',
        text: 'Pay out orders at any time.',
        img_alt: 'POS handheld',
      },
      many_more: {
        title: 'And much more!',
        text: 'Want more details about the best features?',
        button: 'View all features',
      },
    },
  },
  paragraphs: {
    paragraph_1: {
      title: 'Bistroo\'s quick-service POS fully integrated',
      text: 'No complex installations or complicated setup like traditional POS systems. From just €15 per month you have access to a modern POS system designed for quick-service restaurants. No long-term contracts, no hidden costs.',
      cta: 'View POS',
    },
    paragraph_2: {
      title: 'In-store ordering options ready for plug-and-play',
      text: 'Let guests easily order and pay via QR codes and self-service kiosks. Reduce queues, increase order value and serve more guests without extra pressure on your staff. We typically see faster service and higher revenue in the restaurant.',
      cta: 'View Kiosk',
      cta_2: 'View QR',
    },
    paragraph_3: {
      title: 'The only fully self-managed service',
      text: 'The last thing you want as a restaurant or food shop owner is to have to call someone to change your menu. We give you complete control over your data, products, customers and orders!',
      cta: 'View Manager',
    },
  },
  products: {
    pill: {
      label: 'Bistroo Products',
      text: 'Everything we offer',
    },
    heading: 'Choose the solutions that perfectly fit the recipe of your business',
    stop_overspending:
      'Stop overspending on expensive software full of unused features, save costs and increase efficiency.',
    productivity_increase:
      'We typically see an average increase of 20% in productivity and revenue with optimal use of our solutions.',
    start_for_free: 'Start for free now',

    cards: {
      bistroo: 'Bistroo',
      webshop: {
        title: 'Webshop',
        img_alt: 'Bistroo Webshop',
        action: 'View Webshop',
      },
      page: {
        title: 'Website',
        img_alt: 'Bistroo Page',
        action: 'View Page',
      },
      qr: {
        title: 'QR',
        img_alt: 'Bistroo QR',
        action: 'View QR',
      },
      pos: {
        title: 'POS',
        img_alt: 'Bistroo POS',
        action: 'View POS',
      },
      posdevice: {
        title: 'Device',
        img_alt: 'Bistroo Device',
        action: 'View Device',
      },
      kiosk: {
        title: 'Kiosk',
        img_alt: 'Bistroo Kiosk',
        action: 'View Kiosk',
      },
      manager: {
        title: 'Manager',
        img_alt: 'Bistroo Manager',
        action: 'View Manager',
      },
    },
  },
  integrations: {
    heading: 'Use plug-and-play integrations',
    text: 'Manage and optimize online orders by integrating with your favorite tools and POS systems. We\'ve prepared everything — simply connect what you need! It\'s that simple.',
    action: 'View integrations',
  },
  testimonials: {
    pill: {
      label: 'Customer stories',
      text: 'What entrepreneurs say',
    },

    heading: 'These entrepreneurs are already using Bistroo and say..',
    empowered_our_clients: 'Discover how our solutions have brought entrepreneurs success!',

    testimonials: {
      hero: {
        img_alt: 'Mondie Scheepers - Two-B by Mondie',
        text: '"Bistroo saves us a lot of time every day and reduces frustration for our customers, and we\'re also seeing a rise in takeaway orders."',
        author: 'Mondie Scheepers',
        company: 'Two-B by Mondie',
        action: 'Read the full story',
      },

      reviews: {
        one: {
          text: '"Since switching to Bistroo, we no longer have to take phone orders, which saves us valuable time and gives us more room to focus on serving our customers."',
          author: 'Roberta',
          company_role: 'Hostess, Il Municipio',
          action: 'Read story',
        },
        two: {
          text: '"With Bistroo we quickly save over 250 euros a month. Through promotions we also saw more customers coming in via Bistroo. This is beneficial for us since these orders cost significantly less in fees."',
          author: 'Hamza',
          company_role: 'Owner, Grillroom Istanbul',
          action: 'Read story',
        },
        three: {
          text: '"Thanks to Bistroo we have more control over busy periods. Before, phone orders sometimes went unanswered, which likely caused revenue loss. We can clearly see the difference in our numbers."',
          author: 'Henk Boom',
          company_role: "Owner, Cafetaria D'n Boom",
          action: 'Read story',
        },
      },
    },
  },
}
